var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('object-edit-form',{attrs:{"updateQuery":_vm.updateQuery,"selectQuery":_vm.selectQuery,"typeName":_vm.typeName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }